export interface IEnterpriseModel {
  id?: number
  name: string
  token: string
  logo: string
  whiteLogo: string
  navbarBackground: string
  customDomain: string
  customDomainToken: string
}

export const enterpriseInitialState: IEnterpriseModel = {
  name: '',
  token: '',
  logo: '',
  whiteLogo: '',
  navbarBackground: '',
  customDomain: '',
  customDomainToken: '',
}
